module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Position-a5317245d745045dd7f065729689d29b.svg";